<template>
  <div class="fccPublicacoesTVisualizacao">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :status="status"
            :items="listagemApresentacao"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="
            criarTipo.idtipoapresentacao === 0
              ? adicionarTipoApresentacao()
              : editandoTipoApresentacao()
          "
        >
          <div class="row">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.codigounico"
                >Código</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <input type="hidden" v-model="criarTipo.idtipoapresentacao" />
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.tipoapresentacao"
                >Tipo de Apresentação</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-6">
              <label>Possui Valores?</label><br />
              <toggle-button v-model="criarTipo.valores" />
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Tipo de apresentação',
      titlePDF: 'Lista de Tipo de apresentação',
      titleModal: '',
      fields: [
        { key: 'idtipoapresentacao', label: 'Id', sortable: false },
        { key: 'codigounico', label: 'Código', sortable: true },
        { key: 'tipoapresentacao', label: 'Tipo', sortable: true },
        { key: 'status', label: 'Valores', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      listagemApresentacao: [],
      criarTipo: {},
      status: [
        {
          funcaoButton: 'changeTStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'valores',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteTApresentacao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    listarTipoApresentacao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoForm + 'CampoTipoApresentacao/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemApresentacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deleteTApresentacao: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.tipoapresentacao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlGestaoForm + 'CampoTipoApresentacao/Excluir/' + item.idtipoapresentacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTipoApresentacao()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editField: function (_, items) {
      this.criarTipo = items
      this.titleModal = 'Editar tipo de apresentação'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    addField: function () {
      this.criarTipo = {}
      this.criarTipo.idtipoapresentacao = 0
      this.titleModal = 'Adicionar tipo de apresentação'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    changeTStatus: function (_, item) {
      this.criarTipo = item
      this.editandoTipoApresentacao()
    },
    editandoTipoApresentacao: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlGestaoForm + 'CampoTipoApresentacao/Alterando',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoApresentacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionarTipoApresentacao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoForm + 'CampoTipoApresentacao/Adicionar',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoApresentacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlGestaoForm = store.state.baseUrlGestaoForm
    this.listarTipoApresentacao()
  }
}
</script>
